import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import EmailTemplateForm from "./email-template-form"
import EmailTemplateTable from "./email-template-table"
import { useSelector } from "react-redux"
import { userData } from "redux/slice/user/userSlice"
import { SHUK_ROLE_VIWEWER } from "redux/enums"

export default function EmailTemplates() {
  const { userRole } = useSelector(userData)
  const [create, setCreate] = useState(false)
  const [templateData, setTemplateData] = useState({})
  const [updateId, setUpdateId] = useState()

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  useEffect(() => {
    const handlePopState = () => {
      setUpdateId()
      setTemplateData({})
      setCreate(false)
      window.history.pushState(null, null, window.location.href)
    }

    window.history.pushState(null, null, window.location.href)
    window.addEventListener("popstate", handlePopState)
    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  }, [])

  const forUpdate = template_data => {
    let pickForUpdate = {
      id: template_data?.id,
      name: template_data?.name || "",
      key: template_data?.key || "",
      subject: template_data?.subject || "",
      body: template_data?.body || "",
      description: template_data?.description || "",
      category: template_data?.category || "",
      status: template_data?.status || "",
      countries: Array.isArray(template_data?.countries)
        ? template_data.countries
        : [],
      variables: Array.isArray(template_data?.variables)
        ? template_data.variables
        : [],
    }
    setUpdateId(template_data.id)
    setTemplateData(pickForUpdate)
    setCreate(true)
  }

  const toggleTab = () => {
    setUpdateId()
    setTemplateData({})
    setCreate(!create)
  }

  return (
    <div className="">
      {!isViewer && (
        <Row className="mb-2">
          <Col className="justify-content-end d-flex">
            <button className="switch-btn" onClick={toggleTab}>
              {create ? "View" : "Create"}
            </button>
          </Col>
        </Row>
      )}
      {create ? (
        <EmailTemplateForm
          templateData={templateData}
          updateId={updateId}
          toggleTab={toggleTab}
        />
      ) : (
        <EmailTemplateTable forUpdate={forUpdate} />
      )}
    </div>
  )
}
